import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { trigger, animate, transition, style, keyframes } from '@angular/animations';
import { SharedService } from '../../shared/shared.service';
import { TranslateService } from '@ngx-translate/core';
import { DispatchBoardService } from '../../dispatch/dispatchboard/dispatch-board.service';
import { techaddressparam, TechInfo, TechnicianPopupDetails } from '../../dispatch/dispatchboard/dispatch-board.model';
import { LoaderService } from 'app/layout/shared/loader.service';
import { Logo } from 'app/layout/shared/shared.model';

@Component({
    selector: 'technician-popup',
    templateUrl: 'technician-popup.html',
    styleUrls: ['../../dispatch/dispatchboard/dispatch-board.css'],
    animations: [
        trigger('isVisibleChanged', [
            transition('void => *', [
                animate(600, keyframes([
                    style({ opacity: 0, transform: 'translateY(-200px)', offset: 0 }),
                    style({ opacity: 1, transform: 'translateY(25px)', offset: .75 }),
                    style({ opacity: 1, transform: 'translateY(0)', offset: 1 }),
                ]))
            ])
        ])
    ],
    encapsulation: ViewEncapsulation.None
})
export class TechnicianPopupComponent implements OnInit {
    @Output() done = new EventEmitter();
    // @Input() technician: weekview;
    @Input() techid: number;
    @Input() companyid: number;
    @Input() VendorName: string;
    // @Input() view: number;    
    techparam: techaddressparam = new techaddressparam();
    //vendorname: string = "N/A";
    TechInfo: TechnicianPopupDetails;
    tech: TechInfo;
    logo: Logo = new Logo();
    isOpenTechProfile: boolean = false;
    attachment: string;
    tecloader: boolean = false;
    constructor(private sharedService: SharedService, private translate: TranslateService,
        private dispatchService: DispatchBoardService, private loaderService: LoaderService) {
        this.tech = new TechInfo();
        this.TechInfo = new TechnicianPopupDetails();
    }
    ngOnInit() {
        this.techparam.companyid = this.companyid;
        this.techparam.techid = this.techid;        // address
        this.techparam.scheduledate = new Date().toDateString();//no need
        this.techparam.jobid = 0;//no need        
        this.tecloader = true;
        this.dispatchService.getTechnicianPopupDetails(this.techparam).subscribe(types => {
            this.TechInfo = types;
            this.tech = types.TechInfo;
            this.tech.vendorname = this.VendorName;
            this.tecloader = true;
            this.dispatchService.GetTechnicianPhoto(this.companyid, this.tech.PhotoPath).subscribe(p => {                           
                this.tecloader = false;
                this.logo = p;
            }, e => {  this.tecloader = false; });
        }, e => { this.tecloader = false; });

    }
    close(success?: boolean) {
        this.done.emit(true);
    }
    openTechProfile(data) {
        this.attachment = data;
        this.isOpenTechProfile = true;
    }
    closeTechProfile(data) {
        this.isOpenTechProfile = false;
    }
}